import { EXIT_DURATIONS } from '1_components/Transitition/settings';

export const FADE_IN_OUT_ANIMATION = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: EXIT_DURATIONS.max, ease: 'easeInOut' },
};

export const REVEAL_ANIMATION_FULL = {
  initial: { opacity: 0, y: '100%' },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 1, y: '-100%' },
  transition: { duration: EXIT_DURATIONS.max * 1.25, ease: 'easeInOut' },
};

export const REVEAL_ANIMATION = {
  initial: { opacity: 0, y: 30 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: EXIT_DURATIONS.max, ease: 'easeInOut' },
};
